/**
 * 内容使用说明（/settings/data-use；DATA-USE-COPY-01）。从私聊提示、设置页“隐私说明”点“查看内容使用说明”进来；
 * 左上角返回（有站内上一页就退回去，没有就去设置）。内容见 DataUseContent（上传照片处原地打开的面板也用这一份）。
 * 不套主布局、不过入住守卫（接口本身是公开的）。
 */
import { Page, TopBar } from "@/shared/ui";
import { DATA_USE_TITLE, DataUseContent } from "./DataUseContent";

export function DataUsePage() {
  return (
    <Page bare className="ps-data-use">
      <TopBar title={DATA_USE_TITLE} back="/settings" />
      <DataUseContent />
    </Page>
  );
}
